export const ACCOUNT_PAYMENT_FEATURE_LABELS: Record<string, string> = {
  DAILY_PUBLIC_LEAD: '公域线索每日采集',
  DAILY_PRIVATE_LEAD: '私域线索每日采集',
  LEAD_ASSISTANT_ACTIVE_COLLECT_LEAD: '主动采集线索',
  COMMUNITY_OPERATOR: '社群运营官',
  SELF_OPERATED_PRODUCT_DETAIL_VIEW: '自营商品详情',
  AFFILIATE_PRODUCT_DETAIL_VIEW: '达人选品商品详情',
  AFFILIATE_PRODUCT_TEST: '达人选品测品',
  VIDEO_DATA_MONITOR: '投放视频数据',
  ACCOUNT_DATA_MONITOR: '账号数据概况',
  MULTI_DEVICE_LOGIN: '多设备同时登录',
  CREATIVE_PROMPT_ADVANCED_CATEGORY: '高级创作分类',
  ACCOUNT_PLUS: 'Plus 账户套餐',
  ACCOUNT_PRO: 'Pro 账户套餐',
  ACCOUNT_ENTERPRISE: '企业版账户套餐',
  SHOP_CENTER: '店铺数据运营监控',
  BASIC_AUTOMATION: '基础自动化运营能力',
  ADVANCED_AUTOMATION: '高级自动化运营能力',
  BATCH_COLLECT: '批量线索与素材采集',
  PRIORITY_SUPPORT: '专属优先支持',
} as const;

export const ACCOUNT_PAYMENT_LIMIT_LABELS: Record<string, string> = {
  deviceLimit: '设备席位',
  shopLimit: '店铺席位',
  dailyVideoGeneration: '每日生成视频',
  multiDeviceLoginLimit: '同时登录设备',
  leadAssistantSuggestionAccountDailyLimit: '获客助手建议',
  leadAssistantReplyAccountDailyLimit: '获客助手回复',
  leadFollowAccountDailyLimit: '线索跟进',
  competitorAccountLimit: '竞对账号',
  materialVideoDnaAccountDailyLimit: '视频 DNA 分析',
  scriptPromptGenerateAccountDailyLimit: '创意提示词生成',
  creativeCharacterTotalLimit: '创作角色数量',
} as const;

export const ACCOUNT_PAYMENT_RESPONSE_CODES = {
  INSUFFICIENT_COMPUTE_BALANCE: 4001,
  SUBSCRIPTION_REQUIRED: 4002,
  SUBSCRIPTION_EXPIRED: 4003,
} as const;
